import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
import React from 'react';
import { omit } from 'lodash';
import Container from 'brastrap/common/container/Container';
import Rail from 'brastrap/containers/rail/RailContainer';
import ProductPageSkeleton from './ProductPageSkeleton';
import ProductPageRecentlyViewedItems from './ProductPageRecentlyViewedItems';

const STYLE_PREFIX = 'c-product-page';

const ProductPage = props => {
  const {
    isMobile,
    productRecommendations: { config },
    showSkeleton,
    locale,
    currency,
    details,
    gallery,
    styleCode,
  } = props;
  const slidesToShow = (config && config.slidesToShow) || {};
  const productRecommendationsProps = {
    ...omit(props.productRecommendations, ['title', 'introduction', 'config']),
    slidesToShow: isMobile ? +slidesToShow.mobile : +slidesToShow.desktop,
    googleAnalyticsTracking: true,
  };

  return (
    <div className={STYLE_PREFIX}>
      <div className={`${STYLE_PREFIX}__content`}>
        <div className="c-page__main">
          <div className="l-grid">
            <div className="l-grid__unit c-product-page__container c-product-page__container--image">
              {showSkeleton ? (
                <ProductPageSkeleton isMobile={isMobile} type={'gallery'} />
              ) : (
                gallery
              )}
            </div>
            <div className="l-grid__unit c-product-page__container">
              {details}
            </div>
          </div>
        </div>
        {!!(
          props.productRecommendations.items &&
          props.productRecommendations.items.length
        ) && (
          <LazyLoad>
            <Container
              styledTextTitle={props.productRecommendations.title}
              introduction={props.productRecommendations.introduction}
            >
              <Rail {...productRecommendationsProps} />
            </Container>
          </LazyLoad>
        )}
        {props.reviews}
        <ProductPageRecentlyViewedItems
          currency={currency}
          locale={locale}
          isMobile={isMobile}
          details={details}
          styleCode={styleCode}
        />
      </div>
    </div>
  );
};

ProductPage.propTypes = {
  accessories: PropTypes.element.isRequired,
  details: PropTypes.element.isRequired,
  gallery: PropTypes.element.isRequired,
  reviews: PropTypes.element,
  productRecommendations: PropTypes.object,
  isMobile: PropTypes.bool,
  showSkeleton: PropTypes.bool,
  locale: PropTypes.string,
  currency: PropTypes.string,
  styleCode: PropTypes.string,
};

ProductPage.defaultProps = {
  productRecommendations: {},
};

export default ProductPage;
